// Template Generated by DataExtraction.py at 1717541024

import CESGEnglish1 from "../../Forms/CESG/CESG_English1.png";
import CESGEnglish1Labels from "../../Labels/CESG/CESG_English1.json";
import CESGFrench1 from "../../Forms/CESG/CESG_French1.png";
import CESGFrench1Labels from "../../Labels/CESG/CESG_French1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, isFemale, isMale,
    drawText as drawTextAtPos, isAnotherGender,
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import { t } from "i18next";


/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrench1Labels : CESGEnglish1Labels;
    const formImage = isFrench ? CESGFrench1 : CESGEnglish1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const format = "yyyy/MM/DD";
    const beneficiary = data.beneficiary;

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const subscriber2Include = data.common.subscriber2Include;

    let pcgSin;

    if (subscriber.primaryCaregiver) {
        pcgSin = subscriber.sin;
    } else if (subscriber2Include && jointSubscriber.primaryCaregiver) {
        pcgSin = subscriber.sin;
    } else {
        pcgSin = "";
    }

    // // draw provider
    // drawTextAtPos(doc, 12, t("Children's Education Funds Inc."), 53 / 3.38, 240 / 3.38, 454 / 3.38);
    drawText(t("Children's Education Funds Inc."), "respProvider")
    drawText(t("1"), "numBenes")

    // // draw # dependants
    // if (!isFrench) {
    //     drawTextAtPos(doc, 12, t("1"), 467 / 3.38, 854 / 3.38, 10 / 3.38);
    // } else {
    //     drawTextAtPos(doc, 12, t("1"), 469 / 3.38, 857 / 3.38, 10 / 3.38);
    // }

    // Drawing the form
    // TODO implement fields
    drawText(moment(beneficiary.birthdate).format(format), "beneficiaryBirthdateYyyyMmDd");
    fillCheckbox(isFemale(beneficiary.gender), "beneficiaryFemale");
    drawText(beneficiary.firstName, "beneficiaryFirstName");
    drawText(beneficiary.lastName, "beneficiaryLastName");
    fillCheckbox(isMale(beneficiary.gender), "beneficiaryMale");
    fillCheckbox(isAnotherGender(beneficiary.gender), "beneficiaryAnother");
    drawText(beneficiary.sin, "beneficiarySIN");
    drawText(pcgSin, "primaryCaregiverSIN");
    fillCheckbox(!subscriber.custodialParent, "subscriber1CpNo");
    fillCheckbox(subscriber.custodialParent, "subscriber1CpYes");
    drawText(subscriber.firstName, "subscriber1FirstName");
    drawText(subscriber.lastName, "subscriber1LastName");

    if (subscriber.primaryCaregiver || subscriber2Include && jointSubscriber.primaryCaregiver) {
        fillCheckbox(true, "subscriber1PcgYes");
    } else {
        fillCheckbox(true, "subscriber1PcgNo");
    }

    if (subscriber2Include) {
        fillCheckbox(!jointSubscriber.custodialParent, "subscriber2CpNo");
        fillCheckbox(jointSubscriber.custodialParent, "subscriber2CpYes");
        drawText(jointSubscriber.firstName, "subscriber2FirstName");
        drawText(jointSubscriber.lastName, "subscriber2LastName");

        // outdated
        // fillCheckbox(!jointSubscriber.primaryCaregiver, "subscriber2PcgNo");
        // fillCheckbox(jointSubscriber.primaryCaregiver, "subscriber2PcgYes");


    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrench1Labels : CESGEnglish1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
